import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import 'rxjs/add/operator/map';
import { Observable, BehaviorSubject } from 'rxjs';
import { Resp } from './resp.model';

@Injectable()
export class RegService {
      public data: any;
      email: BehaviorSubject<string> = new BehaviorSubject<string>(undefined);

      constructor(private httpclient: HttpClient) { }


      // calls step1 service
      regStepOne(json: string) {
      const headers = new HttpHeaders({ 'Content-Type': 'application/JSON' });
                return this.httpclient.post<Resp>('/reg/eb/StepOne', json, { headers }).map(data => data);
      }

      // calls step2 service
      regStepTwo(json: string) {
      const headers = new HttpHeaders({ 'Content-Type': 'application/JSON' });
                return this.httpclient.post<Resp>('/reg/eb/StepTwo', json, { headers }).map(data => data);
      }

      getQuestion() {
            return this.httpclient.post<any>('/reg/eb/getQuestion', {}).map(resp => resp);
      }

      getMail() {
            return this.httpclient.post<any>('/reg/eb/getMail', {}).map(resp => resp);
      }
      checkDfa() {
            return this.httpclient.post<any>('/reg/eb/dfaCheck', {}).map(resp => resp);
      }

      // loads customer data
      loadData() {
            return this.httpclient.post<any>('/reg/eb/loadData', {}).map(resp => resp);
      }



      getNativeWindow() {
            return window;
      }
}
